import classNames from 'classnames';
import Image from 'components/Image';
import Link from 'components/Link';
import xss from 'utils/xss';
import styles from './StorePageInfo.module.scss';

function formatHours(start, end) {
  const formattedStart =
    start?.toLowerCase().replace(':00', '').replace(' ', '') ?? '';
  const formattedEnd =
    end?.toLowerCase().replace(':00', '').replace(' ', '') ?? '';

  return `${formattedStart}-${formattedEnd}`;
}

function StorePageInfo({
  header,
  contact_info: {
    title: contactInfoTitle,
    contact_options: contactOptions,
  } = {},
  ways_to_shop: { title: waysToShopTitle, shop_options: shopOptions } = {},
  storeHours = [],
  hours_of_operation: { title: hoursOfOperationTitle } = {},
  get_directions: {
    label: getDirectionsLabel,
    link: getDirectionsLink = '',
  } = {},
  shop: { label: checkInventoryLabel, link: checkInventoryLink = '' } = {},
  map_image: mapImage,
  priority,
} = {}) {
  return (
    <div
      className={classNames(
        'd-flex justify-content-center align-items-center',
        styles.info_container
      )}
    >
      <div className="d-flex flex-column-reverse flex-lg-row w-100">
        <div
          className={classNames(`w-100 p-16`, styles.h3_spacing, styles.mw_80)}
        >
          <h4 className={(classNames('fs-18 pb-8'), styles.header)}>
            {header}
          </h4>
          <h3 className={(classNames('fs-9 pb-6'), styles.h3_header)}>
            {contactInfoTitle}
          </h3>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: xss(contactOptions) }}
            className={(classNames('pb-8'), styles.content)}
          />
          <h3 className={(classNames('fs-9 pb-6'), styles.h3_header)}>
            {waysToShopTitle}
          </h3>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: xss(shopOptions) }}
            className={(classNames('pb-16'), styles.content)}
          />
          <h3 className={(classNames('fs-9'), styles.hours_header)}>
            {hoursOfOperationTitle}
          </h3>
          <div className={styles.hours_table}>
            {storeHours && storeHours.length > 0 ? (
              <table>
                <thead />
                <tbody>
                  {storeHours?.map((day) => {
                    return (
                      <tr key={day.day}>
                        <td>{`${day.day}:`}</td>
                        <td>
                          {day.active
                            ? formatHours(day.start, day.end)
                            : 'Closed'}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <div className="mb-8">Store hours unavailable at this time</div>
            )}
          </div>
          <div className="d-flex">
            <Link
              href={getDirectionsLink}
              className={classNames(
                'btn btn-secondary me-4 w-100 p-7',
                styles.store_button
              )}
              target="_blank"
              rel="noreferrer"
            >
              {getDirectionsLabel}
            </Link>
            <a
              className={classNames(
                'btn btn-secondary ms-4 w-100 p-7',
                styles.store_button
              )}
              href={checkInventoryLink.replaceAll('.', '')}
            >
              {checkInventoryLabel}
            </a>
          </div>
        </div>
        <Link
          href={getDirectionsLink}
          target="_blank"
          rel="noreferrer"
          className={classNames(
            'position-relative',
            'd-flex justify-content-center align-items-center',
            'w-100 mw-100 mh-100 p-16',
            styles.image
          )}
        >
          <Image
            fill
            priority={priority}
            alt={mapImage?.alt_text}
            className="p-16"
            objectFit="cover"
            sizes="(max-width: 991px) 100vw, 50vw"
            src={mapImage?.file?.url}
          />
        </Link>
      </div>
    </div>
  );
}

export default StorePageInfo;
